import {
  Box,
  Center,
  createStyles,
  Modal,
  Paper,
  ScrollArea,
  Table,
  Text,
} from "@mantine/core";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";
import { useState } from "react";
import moment from 'moment-timezone';

const useStyles = createStyles(() => ({
  mainbox: {
    background: "#F5F5F5",
    padding: "13px 19px",
    paddingTop: "28px",
    width: "100%",
  },

  tableRoot: {
    "tbody tr:hover td": {
      backgroundColor: "#FFF6ED !important",
    },
  },
  outerbox: {
    marginTop: "14px",
    padding: "20px 20px 80px",
    borderRadius: "12px",
    border: "1px solid #E5E5E5",
    background: "#FFF",
  },

  tbody: {
    color: "#000 !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
  },
}));
const bgColor = "#FFFFFF";

const BillingHistory = ({ billinghistory, SetBillinghistory, billing }) => {
  const { classes } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [loading, setLoading] = useState(false);

   function formatToLocalDisplayDate(utcString) {
  if (!utcString) return '';

  const localTime = moment.utc(utcString).tz(moment.tz.guess());
  return localTime.format('MM/DD/YY (hh:mm A)');
}

  const handleClose = () => {
    SetBillinghistory(false);
  };

  // console.log('billing',billing);

  const dummyData = [
    {
      uploadDate: "06/14/25 12:00 PM",
      description: "Uploaded in file: Morning Star Group Home",
    },
    {
      uploadDate: "06/14/25 12:00 PM",
      description: "Uploaded in file: Morning Star Group Home",
    },
    {
      uploadDate: "06/14/25 12:00 PM",
      description: "Uploaded in file: Morning Star Group Home",
    },
    {
      uploadDate: "06/14/25 12:00 PM",
      description: "Uploaded in file: Morning Star Group Home",
    },
    {
      uploadDate: "06/14/25 12:00 PM",
      description: "Uploaded in file: Morning Star Group Home",
    },
  ];

  return (
    <Modal
      opened={billinghistory}
      size={1000}
      shadow="md"
      title="Claim History"
      // title="View Details (CMS 1500)"
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
          //   padding:'13px 19px'
        },
      }}
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius="lg"
      zIndex={1000}
      centered
      sx={{
        ".mantine-1q36a81": {
          padding: "0",
        },
      }}
    >
      <Box className={classes.mainbox}>
        <Text ff="Inter" fz={14} fw={500} color="#171717">
          Claim ID: {billing?.claim?.claimmd_id}
        </Text>

        <Box className={classes.outerbox}>
          <Box className={classes.innerbox}>
            {loading ? (
              <TableLoader />
            ) : (
              <ScrollArea
                onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                sx={{ minHeight: "300px" }}
              >
                <Paper
                  sx={{
                    borderRadius: "8px !important",
                    border: "1px solid #E5E5E5 !important",
                  }}
                  withBorder
                >
                  <Table
                    highlightOnHover
                    className={classes.tableRoot}
                    withColumnBorders={false}
                    sx={{
                      fontFamily: "Inter",
                      "tbody tr:hover": {
                        backgroundColor: "#FFF6ED !important",
                      },
                    }}
                    fontSize="sm"
                    verticalSpacing="md"
                  >
                    <thead>
                      <tr>
                        <th>
                          <Text ff="Inter" fz={14} fw={700} color="#000">
                            Date/Time
                          </Text>
                        </th>
                        <th>
                          <Text ff="Inter" fz={14} fw={700} color="#000">
                            Note
                          </Text>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {billing?.claim?.billingHistory?.map((item, index) => {
                        const bg = index % 2 === 0 ? "#f9f9f9" : "#ffffff";

                        return (
                          <tr key={index} style={{ backgroundColor: bg }}>
                            <td className={classes.tbody}>
                              {formatToLocalDisplayDate(item?.date)}
                             </td>
                            <td className={classes.tbody}>
                              {item?.note || '-'}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Paper>
              </ScrollArea>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BillingHistory;
